import digitalData from 'digital-data';
import { INTERACTION, PIP_SUB_CONTENT, SHARING } from '../constants';

export const sharebelt = () => {

  window.LIFE_CYCLE_EVENT_BUS.on('@@SHARE-BELT/CLICK', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@SHARE-BELT/CLICK is deprecated.', 'background: red; color: black', payload);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('thd-sharebelt.click', ({ output }) => {
    const {
      component,
      target
    } = output;

    const ddoEvent = {
      category: {
        primaryCategory: INTERACTION
      },
      eventInfo: {
        eventName: PIP_SUB_CONTENT
      },
      subContent: {
        section: SHARING,
        component,
        target
      }
    };
    (digitalData.event || []).push(ddoEvent);
  });
};
